import React from 'react';
import Helmet from 'react-helmet';
import {StaticQuery, graphql} from 'gatsby';

import PageHeader from 'components/page-header';
import {Text, P} from 'components/typography';
import Section, {SectionTitle} from 'components/section';
import Site from 'components/site';
import {Inner} from 'components/system';

const ProfilePage = ({data}) => {
  const meta = data.site.siteMetadata;
  return (
    <Site>
      <main>
        <Helmet title={`Profile - ${meta.defaultTitle}`}>
          <meta
            name="twitter:title"
            content={`Profile - ${meta.defaultTitle}`}
          />
          <meta name="twitter:description" content={meta.defaultDescription} />
        </Helmet>
        <PageHeader title="Profile" />
        <Inner>
          <Section>
            <P>
              我叫Bask，是一个Android工程师，现居上海。
              虽然主业是Android App开发，但是对于其他方面，比如iOS、前端、Flutter等方向都有些涉猎。
            </P>
            <P>
              我除了致力于Android App开发外，还喜欢创造一些工具与UI控件，让开发进程变得更便捷
              ，页面变得更炫美。
              我现在在{' '}
              <a
                href="https://ctrip.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Ctrip
              </a>
              工作，致力于Android支付方面的相关工作。
            </P>
          </Section>
          <Section>
            <SectionTitle>Experience</SectionTitle>
            <P fontWeight={500}>Ctrip (2016 - present)</P>
            <P>
              目前致力于携程Android端支付模块的开发及维护。模块集成于携程集团下多个项目中。
              包括携程银联二维码、中文版、国际版、支付对外SDK等项目。以上项目均用Kotlin及
              Java混合开发，部分核心逻辑使用JNI保证支付内部安全性。通过高效的开发及问题处理
              保证业务需求及模块优化可以及时交付。
            </P>
            <br/>
            <P>♾ 其他项目包括：</P>
            <P>- 与CBU共同制定服务端传参技改。</P>
            <P>- 开发性能检测工具帮助开发定位问题原因。</P>
            <br/>
            <P fontWeight={500}>鲑鱼科技 (2015 - 2016)</P>
            <P>
              以Android开发身份加入鲑鱼科技，作为小鱼停车App Android端的主力开发，搭建Android端框架及构建业务模型。
            </P>
            <P>
              同时也帮助产品经理完善App设计上的不足并且在内网中立了开发指南，帮助其他开发人员提升开发效率。
            </P>
          </Section>

          <Section>
            <SectionTitle>Personal projects</SectionTitle>
            <Text>
              <a href="https://github.com/DuanTzXavier/AOPDemo">
                remix - fast using aop
              </a>
            </Text>
            <Text>
              <a href="https://github.com/DuanTzXavier/calculator">
              calculator - Writen with flutter
              </a>
            </Text>
            <Text>
              <a href="https://github.com/DuanTzXavier/conciseclock">
              conciseclock - a cut time clock
              </a>
            </Text>
          </Section>

          {/* <Section>
            <SectionTitle>Writing</SectionTitle>
            <Text>Net mag - side project of the month: JuniorJobs (2017)</Text>
            <Text>
              Net mag - How to get started with pattern libraries (2016)
            </Text>
            <Text>Net mag - Design Challenge (2014)</Text>
            <Text>WebDesignerMag - Spotlight Interview (2014)</Text>
          </Section> */}
          {/* <Section>
            <SectionTitle>Resume</SectionTitle>
            <Text>
              <a href="https://alexpate.s3.amazonaws.com/resume.pdf">
                Download as PDF
              </a>
            </Text>
          </Section> */}
        </Inner>
      </main>
    </Site>
  );
};

export default () => (
  <StaticQuery
    query={graphql`
      query ProfileQuery {
        site {
          siteMetadata {
            defaultTitle
            defaultDescription
          }
        }
      }
    `}
    render={data => <ProfilePage data={data} />}
  />
);
